import { render, staticRenderFns } from "./Brandings.vue?vue&type=template&id=0a61306c&scoped=true"
import script from "./Brandings.vue?vue&type=script&lang=js"
export * from "./Brandings.vue?vue&type=script&lang=js"
import style0 from "./Brandings.vue?vue&type=style&index=0&id=0a61306c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a61306c",
  null
  
)

export default component.exports